const swal = require('sweetalert')

const onboardingService = require("../../../../services/onboard")
var tokens = [0, 0, 0, 0, 0]
export async function load() {



    try {
        const formEL = document.getElementById("etapa_8");
        const userID = formEL.getAttribute("userID");
        await requestNewToken(userID);
        await addEventListenerToInputs(userID);
        addEventListenerToRequestToken();

        formEL.addEventListener('submit', evt => {
            evt.preventDefault();
            sendForm(evt.target);
        });

        return true

    } catch (err) {
        console.log('err', err)
        return err
    }


}


async function requestNewToken(userID) {
    var generatedToken = await onboardingService.generateNewToken(userID);
    generatedToken = generatedToken.json();

    return generatedToken;
}

async function resendToken(userID) {
    var generatedToken = await onboardingService.resendToken(userID);
    generatedToken = generatedToken.json();

    const requestTokenElement = document.getElementById('resendToken');
    const disabled = requestTokenElement.classList.contains('disabled');

    if (disabled) {
        const modal = document.querySelector('.custom-modal');

        if (modal.classList.contains('d-none')) {
            modal.classList.remove('d-none');

            const closeButton = modal.querySelector('.times-icon');

            closeButton.addEventListener('click', (_) => closeModal());

            const closeModalButton = modal.querySelector('#closeModalButton');

            closeModalButton.addEventListener('click', (_) => closeModal());

            const closeModalBackground = modal.querySelector('.modal-close-div');

            closeModalBackground.addEventListener('click', (_) => closeModal());
        }
    }

    return generatedToken;
}

function closeModal() {
    const requestTokenElement = document.getElementById('resendToken');

    const disabled = requestTokenElement.classList.contains('disabled');
    if (disabled) {
        requestTokenElement.classList.remove('disabled');
    }

    const modal = document.querySelector('.custom-modal');

    if (!modal.classList.contains('d-none')) {
        modal.classList.add('d-none');
    }

}

async function sendForm(formEL) {
    const userID = formEL.getAttribute("userID")
    var tokensInput = Array.from(document.getElementsByClassName("number-token"));

    let tokenFinal = '';

    tokensInput.forEach((numberToken) => {
        tokenFinal += numberToken.value
    });

    try {
        const button = document.getElementById('sendButton');

        if (!button.classList.contains('loading')) {
            button.classList.add('loading');
        }

        var sendToken = await onboardingService.verifytoken(userID, tokenFinal)

        if (sendToken.status == 200) {
            window.barba.go(`/cadastro/etapa_9?registerType=ong_2`);
        } else {
            swal({
                title: 'Erro!',
                text: 'Token inválido',
                icon: 'error',
                confirmButtonText: 'Fechar'
            });
        }


        if (button.classList.contains('loading')) {
            button.classList.remove('loading');
        }
    } catch (err) {
        swal({
            title: 'Erro interno no servidor',
            text: 'Por favor tente mais tarde',
            icon: 'error',
            confirmButtonText: 'OK'
        });
        if (button.classList.contains('loading')) {
            button.classList.remove('loading');
        }
    }
}

function addEventListenerToRequestToken() {
    document.getElementById('resendToken').addEventListener('click', (e) => {
        const formEL = document.getElementById('etapa_8');
        if (!e.target.classList.contains('disabled')) {
            e.target.classList.add('disabled');
        }
        const userID = formEL.getAttribute("userID");
        resendToken(userID)
    });
}


async function addEventListenerToInputs(userID) {

    var tokensInput = Array.from(document.getElementsByClassName("number-token"))
    tokensInput.forEach((numberToken, i) => {
        numberToken.addEventListener('keyup', async (e) => {
            tokens[i] = e.target.value;

            if ((i + 1) < tokensInput.length) {
                tokensInput[i + 1].focus();
            } else {

                var tokenFinal = tokens.toString();
                tokenFinal = tokenFinal.replaceAll(',', '')
                try {
                    var sendToken = await onboardingService.verifytoken(userID, tokenFinal)

                    if (sendToken.status == 200) {
                        window.barba.go(`/cadastro/etapa_9?registerType=ong_2`);
                    } else {
                        swal({
                            title: 'Erro!',
                            text: 'Token inválido',
                            icon: 'error',
                            confirmButtonText: 'Tentar novamente'
                        });
                    }
                } catch (err) {
                    swal({
                        title: 'Erro interno no servidor',
                        text: 'Por favor tente mais tarde',
                        icon: 'error',
                        confirmButtonText: 'OK'
                    });
                }

            }

        })
    });
}
